import chevronTable from '../../../../../../assets/icons/chevronTable.svg';
import InvestifyWTAC from '../../../../../../assets/icons/InvestifyWTAC.svg';
import { InvestifyInvestmentListProps } from '../../../../../../types';

const InvestifyInvestmentList = ({ items, onItemClick }: InvestifyInvestmentListProps) => (
  <div className="investify-table">
    {items.map((item) => (
      <div key={item.investId} className="investify-table__item pointer" onClick={() => onItemClick(item)}>
        <img
          src={item.image}
          className="investify-table__item-image"
          alt=""
          onError={(e) => {
            e.currentTarget.src = InvestifyWTAC;
          }}
        />

        <div className="investify-table__item-details">
          <h3 className="investify-table__item-detailstitle">{item.title}</h3>
          <span className="investify-table__item-details-id">{item.investId}</span>
        </div>

        <div className="investify-table__item-returns-info">
          <h4 className="investify-table__item-returns-info-amount">{item.keyPoints?.[0]?.value}</h4>
          <div className="investify-table__item-returns-info-details">
            <span style={{ color: item.returnsInfo?.percentStyle?.color || '#6624CE' }}>
              {item.returnsInfo?.percent}
            </span>{' '}
            <span>{item.returnsInfo?.returnsText}</span>
          </div>
        </div>
        <img className="chevron-table" src={chevronTable} alt="" />
      </div>
    ))}
  </div>
);

export default InvestifyInvestmentList;
